import type { MotionProps } from 'framer-motion';

export const getSectionContentMotionProps = ({
  isVisible,
}: {
  isVisible: boolean;
}): MotionProps => {
  const opacity = isVisible ? 1 : 0;

  return {
    animate: {
      filter: isVisible ? 'blur(0)' : 'blur(5px)',
      opacity,
    },
    initial: {
      filter: 'blur(5px)',
      opacity,
    },
    transition: {
      duration: 0.75,
      type: 'tween',
    },
  };
};
